import {
  FileImageOutlined,
  FileOutlined,
  FilePdfOutlined,
  FolderFilled,
  VideoCameraOutlined,
} from '@ant-design/icons';
import React, { useRef } from 'react';
import { useMediaThumbnail } from '../../../../utils/api/medias/useMediaThumbnail';
import { canHaveThumbnail } from './mediaPath';
import { useIsVisible } from './useIsVisible';

const TILE_HEIGHT = 120;

const TYPE_ICONS = {
  image: FileImageOutlined,
  video: VideoCameraOutlined,
  document: FilePdfOutlined,
};

const TYPE_COLORS = { image: '#0958d9', video: '#531dab', document: '#a8071a' };

const TypeIcon = ({ record }) => {
  if (record.isFolder) {
    return (
      <FolderFilled aria-hidden style={{ fontSize: 72, color: '#faad14' }} />
    );
  }
  const Icon = TYPE_ICONS[record.media_type] ?? FileOutlined;
  return (
    <Icon
      aria-hidden
      style={{
        fontSize: 48,
        color: TYPE_COLORS[record.media_type] ?? '#595959',
      }}
    />
  );
};

// Vignette d'un élément : miniature pour les images (chargée seulement une fois
// visible), icône du type sinon ou tant que la miniature n'est pas prête.
const LibraryThumbnail = ({ record }) => {
  const ref = useRef(null);
  const wantsThumbnail = !record.isFolder && canHaveThumbnail(record);
  const isVisible = useIsVisible(ref);
  const { url } = useMediaThumbnail(record.path, {
    enabled: wantsThumbnail && isVisible,
  });

  return (
    <div
      ref={ref}
      style={{
        height: TILE_HEIGHT,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 6,
        background: record.isFolder ? 'transparent' : '#fafafa',
        overflow: 'hidden',
      }}
    >
      {url ? (
        <img
          src={url}
          alt=""
          style={{
            maxWidth: '100%',
            maxHeight: TILE_HEIGHT,
            objectFit: 'contain',
          }}
        />
      ) : (
        <TypeIcon record={record} />
      )}
    </div>
  );
};

export default LibraryThumbnail;
